import React from 'react'
import { Input } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

const SearchInput = ({ handleSearch, loading, token }) => {
  return (
    <Input
      placeholder='Search appointments...'
      prefix={
        <span
          style={{
            background: token.actionColor,
            borderRadius: '50%',
            width: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '8px'
          }}
        >
          <FontAwesomeIcon icon={faSearch} style={{ color: 'white', fontSize: '12px' }} />
        </span>
      }
      allowClear
      onChange={handleSearch}
      style={{
        width: '400px',
        maxWidth: '100%',
        borderRadius: '6px',
        height: '40px'
      }}
      disabled={loading}
      size='middle'
    />
  )
}

export default SearchInput
